import {createReducer} from 'redux-act';
import {FULFILLED} from 'redux-promise-middleware';

import {WIZARD} from 'constants/actions';

export const initialState = {
    colors: {
        groups: [],
    },
    status: 'pending',
    wizardMock: {
        usage: [],
        packages: {},
        insurances: {},
        additionalOptions: [],
    },
    activeStep: 'usage',
};

export const wizard = createReducer(
    {
        [`${WIZARD.FETCH}_${FULFILLED}`]: (state, payload) => ({
            ...state,
            wizardMock: {
                ...payload.data,
            },
            status: 'fulfilled',
        }),
        [WIZARD.RESET]: () => initialState,
        [`${WIZARD.GET_PRODUCT_WIZARD}_${FULFILLED}`]: (state, payload) => {
            if (payload.data.use_for || payload.data.contact_lens_prescription) {
                return {
                    ...state,
                    ...payload.data.use_for,
                    ...payload.data,
                    status: 'fulfilled',
                };
            }
            return {...initialState, status: 'rejected'};
        },
        [WIZARD.SET_ACTIVE_STEP]: (state, payload) => ({
            ...state,
            activeStep: payload,
        }),
    },
    initialState,
);
